<template>
  <div class="member-evaluation-collect" v-loading="loading">
    <EvaluationEmpty v-show="!loading && isEmpty"></EvaluationEmpty>
    <div v-show="!loading && !isEmpty">
      <div class="total">
        <p class="num">{{ totalNum }}</p>
        <p class="label">题目数</p>
        <div class="btn-wrap">
          <el-button type="primary" size="medium" @click="onWatch(null)">
            查看全部收藏
          </el-button>
        </div>
      </div>
      <div class="detail">
        <ul class="tabs-simple">
          <li
            v-for="(item, index) in tabs"
            :key="index"
            :class="{ active: item.type == searchCondition.type }"
          >
            {{ item.label }}
          </li>
        </ul>
        <p class="btn" @click="onClearCollect">
          <i></i>
          <span>清空收藏</span>
        </p>
        <TreeCollapse
          :value="treeData"
          :header-title="['名称', '题目数', '操作']"
          child-prop="child"
        >
          <template slot="num" slot-scope="{ data }">
            {{ data.ques_num }}
          </template>
          <template slot="btn" slot-scope="{ data }">
            <el-button type="primary" size="small" @click="onWatch(data)">
              查看
            </el-button>
          </template>
        </TreeCollapse>
      </div>
    </div>
  </div>
</template>

<script>
import TreeCollapse from "../exam/components/TreeCollapse";
import EvaluationEmpty from "./EvaluationEmpty";
export default {
  name: "member-evaluation-collect",
  components: {
    TreeCollapse,
    EvaluationEmpty,
  },
  data() {
    return {
      isEmpty: true,
      loading: true,
      tabs: [{ type: 3, label: "知识点分类" }],
      searchCondition: {
        type: 3,
      },
      treeData: [],
      totalNum: 0,
    };
  },
  created() {
    this.requestData();
  },
  methods: {
    // on event
    onWatch(val) {
      let query = {
        collectType: 3,
        collectTypeID: val ? val.id : 0,
        from: "collect",
      };
      this.$router.push({
        name: "ExamWrongDo",
        query: query,
      });
    },
    async onClearCollect() {
      await this.$promiseConfirm("确定要清空已收藏的题目吗？");
      await this.$http.post("/api/app/collect/quesClear", this.searchCondition);
      this.$success("清空收藏成功");
      this.requestData();
    },
    // other
    getData() {
      this.requestData();
    },
    // request
    requestData() {
      this.loading = true;
      this.$http
        .get("/api/app/collect/quesByPoint", this.searchCondition, {
          showLoading: false,
        })
        .then(data => {
          this.totalNum = data.all_ques_num;
          this.treeData = data.point_list;
          this.loading = false;
          this.isEmpty = !this.totalNum;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.member-evaluation-collect {
  min-height: 738px;
  .total {
    text-align: center;
    position: relative;
    border-bottom: 1px solid #ededed;
    padding: 15px 0 30px;
    margin-bottom: 27px;
    .num {
      color: #333;
      font-size: 42px;
      line-height: 1;
      font-weight: 500;
      margin-bottom: 11px;
    }
    .label {
      color: #666;
      font-size: 15px;
      line-height: 1;
      margin-bottom: 19px;
    }
  }
  .detail {
    position: relative;
    .tabs-simple {
      margin-bottom: 15px;
      li {
        cursor: auto;
      }
    }
    .btn {
      color: #999;
      font-size: 16px;
      line-height: 1;
      position: absolute;
      top: 0;
      right: 5px;
      cursor: pointer;
      i {
        display: inline-block;
        width: 19px;
        height: 19px;
        vertical-align: middle;
        margin-right: 6px;
        background: url("~@/assets/images/exam/trash.png") no-repeat center /
          contain;
      }
      span {
        vertical-align: middle;
      }
      &:hover {
        color: $primary-color;
        i {
          background-image: url("~@/assets/images/exam/trash-checked.png");
        }
      }
    }
  }
}
</style>
